import React, { useState } from "react";
import { CloseCircleOutlined, CloseOutlined, LogoutOutlined } from "@ant-design/icons";
import { Alert, Button, Modal } from "antd";

/* ══════════════════════════════════════════════════════ */
/*  NOTE TEXT AREA — separate sub-component              */
/* ══════════════════════════════════════════════════════ */
function CheckOutNoteArea({ value, onChange }) {
    return (
        <div style={{ marginTop: 16 }}>
            <label style={{
                display: "block",
                fontSize: 12,
                fontWeight: 600,
                color: "#555",
                marginBottom: 6,
                textTransform: "uppercase",
                letterSpacing: 0.4,
            }}>
                Cancel Reservation Note{" "}
                <span style={{ color: "#aaa", fontWeight: 400, textTransform: "none", fontSize: 11 }}>
                    (optional)
                </span>
            </label>
            <textarea
                placeholder="Add any remarks, damages, or notes about this Cancel Reservation…"
                value={value}
                rows={3}
                onChange={(e) => onChange(e.target.value)}
                style={{
                    width: "100%",
                    border: "1.5px solid #e4e4e4",
                    borderRadius: 8,
                    fontSize: 13,
                    color: "#222",
                    padding: "8px 12px",
                    outline: "none",
                    resize: "vertical",
                    boxSizing: "border-box",
                    background: "#fafafa",
                    fontFamily: "inherit",
                    lineHeight: 1.5,
                }}
            />
        </div>
    );
}


export default function CancleCheckModal({ open, onClose, onConfirm, form, room, loading }) {

    // console.log("form",form);
    
    const [note, setNote] = useState("");

    const handleConfirm = () => {
        onConfirm({ status: "cancel", note, form });

        
    };

    const handleCancel = () => {
        setNote("");
        onClose();
    };

   // Add this near the top inside the component:
const hasGuestDetails =
    form?.guest_name || form?.phone || form?.email;

// Replace your return with this:
return (
    <>
        {!hasGuestDetails ? (
            <Modal
                open={open}
                onCancel={handleCancel}
                footer={[
                    <Button key="close" type="primary" onClick={handleCancel}>
                        Close
                    </Button>,
                ]}
                centered
                width={450}
                destroyOnClose
                title={
                    <div style={{ display: "flex", alignItems: "center", gap: 8, color: "#000000ff" }}>
                        <CloseCircleOutlined style={{ fontSize: 20 }} />
                        <span style={{ fontWeight: 700, fontSize: 15 }}>
                            Guest Details Not Found
                        </span>
                    </div>
                }
            >
                <Alert
                    type="warning"
                    showIcon
                    message={
                        <span style={{ fontWeight: 600 }}>
                            User details not found or guest has not checked in yet.
                        </span>
                    }
                    description="Please verify reservation/check-in status before attempting cancellation."
                />
            </Modal>
        ) : (
            <Modal
                open={open}
                onCancel={handleCancel}
                title={
                    <div style={{ display: "flex", alignItems: "center", gap: 8, color: "#c41d1dff" }}>
                        <CloseCircleOutlined style={{ fontSize: 20 }} />
                        <span style={{ fontWeight: 700, fontSize: 15 }}>
                            Confirm Cancel Reservation
                        </span>
                    </div>
                }
                footer={[
                    <Button key="cancel" onClick={handleCancel}>
                        Cancel
                    </Button>,
                    <Button
                        key="confirm"
                        danger
                        type="primary"
                        loading={loading}
                        icon={<CloseCircleOutlined />}
                        onClick={handleConfirm}
                    >
                        Confirm Cancel Reservation
                    </Button>,
                ]}
                width={800}
                centered
                destroyOnClose
            >
                {/* Guest summary alert */}
                <Alert
                    type="error"
                    showIcon
                    message={
                        <span style={{ fontWeight: 600 }}>
                            You are about to Cancel Reservation of this guest. Please review the details below.
                        </span>
                    }
                    description={
                        <div
                            style={{
                                marginTop: 10,
                                display: "grid",
                                gridTemplateColumns: "repeat(3, 1fr)",
                                gap: "6px 20px",
                            }}
                        >
                            {[
                                ["Guest Name", form?.guest_name || "—"],
                                ["Phone", form?.phone || "—"],
                                ["Email", form?.email || "—"],
                                ["Room", room?.room_name || "—"],
                                ["Room No.", `#${room?.room_number || "—"}`],
                                ["Guests", form?.guests ?? "—"],
                            ].map(([k, v]) => (
                                <div
                                    key={k}
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: 1,
                                    }}
                                >
                                    <span
                                        style={{
                                            fontSize: 10,
                                            color: "#888",
                                            textTransform: "uppercase",
                                            letterSpacing: 0.4,
                                            fontWeight: 600,
                                        }}
                                    >
                                        {k}
                                    </span>
                                    <span
                                        style={{
                                            fontSize: 13,
                                            fontWeight: 600,
                                            color: "#222",
                                        }}
                                    >
                                        {v}
                                    </span>
                                </div>
                            ))}
                        </div>
                    }
                />

                <Alert
                    type="info"
                    description={
                        <div
                            style={{
                                marginTop: 10,
                                display: "grid",
                                gridTemplateColumns: "repeat(3, 1fr)",
                                gap: "6px 20px",
                            }}
                        >
                            {[
                                ["Payment Mode", form?.payment_mode || "—"],
                                ["Check-In", form?.check_in + ", " + form?.check_in_time || "—"],
                                ["Est. Check-Out", form?.check_out + ", " + form?.check_out_time || "—"],
                            ].map(([k, v]) => (
                                <div
                                    key={k}
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: 1,
                                    }}
                                >
                                    <span
                                        style={{
                                            fontSize: 10,
                                            color: "#888",
                                            textTransform: "uppercase",
                                            letterSpacing: 0.4,
                                            fontWeight: 600,
                                        }}
                                    >
                                        {k}
                                    </span>
                                    <span
                                        style={{
                                            fontSize: 13,
                                            fontWeight: 600,
                                            color: "#222",
                                        }}
                                    >
                                        {v}
                                    </span>
                                </div>
                            ))}
                        </div>
                    }
                />

                <CheckOutNoteArea value={note} onChange={setNote} />
            </Modal>
        )}
    </>
);
}